<template>
  <div>
    <div class="pieChart"></div>
    <!-- <div
      class="legend"
      v-show="safeRouteV2.filter(d => d[Object.keys(d)]).length > 0"
    >
      <div style="color:#a05121">
        {{ safePercent[0].highstress }}% - High-Traffic
      </div>
      <div style="color:#5a7ebc">
        {{ safePercent[1].residential }}% - Residential
      </div>
      <div style="color:#5e8b79">
        {{ safePercent[2].cycleway }}% - Dedicated BikePath
      </div>
      <div style="color:#8d8d8d">
        {{ safePercent[3].other }}% - Miscellaneous
      </div>
    </div> -->
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import * as d3 from "d3";
import { mapState } from "vuex";

export default {
  props: {
    refreshStats: {
      type: Boolean
    },
    markerList: {
      type: Array
    },
    localMapIsStatic: {
      type: Boolean
    }
  },
  mounted() {
    this.createVueD3Chart();
  },
  data() {
    return {
      toggle: false,
      statscalced: false,
      stats: {
        offsetCO2: null,
        safe: {
          primary: null,
          secondary: null,
          tertiary: null,
          residential: null,
          cycleway: null,
          other: null
        },
        safeTotal: null,
        risky: {
          primary: null,
          secondary: null,
          tertiary: null,
          residential: null,
          cycleway: null,
          other: null
        },
        riskyTotal: null
      }
    };
  },
  watch: {
    refreshStats() {
      this.calcStats();
      this.roundStats();
      this.updateChart();
      this.tellHUD();
    },
    uiRouteType() {
      this.updateChart();
    }
  },
  computed: {
    ...mapState(["uiRouteType"]),
    safePercent() {
      if (this.uiRouteType == "Safe") {
        return [
          {
            highstress: Math.round(
              ((this.stats.safe.primary +
                this.stats.safe.secondary +
                this.stats.safe.tertiary) /
                this.safeTotalV2) *
                100
            )
          },
          {
            residential: Math.round(
              (this.stats.safe.residential / this.safeTotalV2) * 100
            )
          },
          {
            cycleway: Math.round(
              (this.stats.safe.cycleway / this.safeTotalV2) * 100
            )
          },
          {
            other: Math.round((this.stats.safe.other / this.safeTotalV2) * 100)
          }
        ];
      } else {
        return [
          {
            highstress: Math.round(
              ((this.stats.risky.primary +
                this.stats.risky.secondary +
                this.stats.risky.tertiary) /
                this.riskyTotalV2) *
                100
            )
          },
          {
            residential: Math.round(
              (this.stats.risky.residential / this.riskyTotalV2) * 100
            )
          },
          {
            cycleway: Math.round(
              (this.stats.risky.cycleway / this.riskyTotalV2) * 100
            )
          },
          {
            other: Math.round(
              (this.stats.risky.other / this.riskyTotalV2) * 100
            )
          }
        ];
      }
    },
    safeRouteV2() {
      return [
        {
          highstress:
            this.stats.safe.primary +
            this.stats.safe.secondary +
            this.stats.safe.tertiary
        },
        { residential: this.stats.safe.residential },
        { cycleway: this.stats.safe.cycleway },
        { other: this.stats.safe.other }
      ];
    },
    safeTotalV2() {
      return (
        this.safeRouteV2[0].highstress +
        this.safeRouteV2[1].residential +
        this.safeRouteV2[2].cycleway +
        this.safeRouteV2[3].other
      );
    },
    riskyTotalV2() {
      return (
        this.riskyRouteV2[0].highstress +
        this.riskyRouteV2[1].residential +
        this.riskyRouteV2[2].cycleway +
        this.riskyRouteV2[3].other
      );
    },
    riskyRouteV2() {
      return [
        {
          highstress:
            this.stats.risky.primary +
            this.stats.risky.secondary +
            this.stats.risky.tertiary
        },
        { residential: this.stats.risky.residential },
        { cycleway: this.stats.risky.cycleway },
        { other: this.stats.risky.other }
      ];
    }
  },
  methods: {
    tellHUD() {
      let total =
        this.uiRouteType == "Safe" ? this.safeTotalV2 : this.riskyTotalV2;
      this.$emit("pieSaysUpdateHUD", [this.stats.offsetCO2, total]);
    },
    roundStats() {
      this.stats.offsetCO2 = Math.round(this.stats.offsetCO2 * 100) / 100;
      [
        // "total",
        "primary",
        "secondary",
        "tertiary",
        "residential",
        "cycleway",
        "other"
      ].map(roadtype => {
        ["safe", "risky"].map(route => {
          this.stats[route][roadtype] =
            Math.round((this.stats[route][roadtype] / 1609.34) * 100) / 100;
        });
      });
    },
    calcStats() {
      let yourCarMPG = 25;
      let carDistance = 0;
      var sum = 0;

      ["safe", "risky"].map(route => {
        [
          // "total",
          "primary",
          "secondary",
          "tertiary",
          "residential",
          "cycleway",
          "other"
        ].map(road => {
          this.stats[route][road] = 0;
        });
        this.stats.offsetCO2 = 0;
      });

      for (var i = 1; i < this.markerList.length; i++) {
        // this.stats.safe.total =
        //   this.stats.safe.total + this.markerList[i].gh.safe.paths[0].distance;

        // this.stats.risky.total =
        //   this.stats.risky.total +
        //   this.markerList[i].gh.risky.paths[0].distance;

        carDistance =
          carDistance + this.markerList[i].gh.carCO2.paths[0].distance;
        // console.log(carDistance / 1609.34);
        // this.safeStats = this.markerList[i].gh.safe.paths[0].distance / 1609.34; //convert meters to miles
      }
      this.stats.offsetCO2 = (carDistance / yourCarMPG / 1609.34) * 20; //The 20 is for the 20lbs of CO2 produced per gallon of gas burned

      let markersWithRoutes = this.markerList.filter(
        e => this.markerList.indexOf(e) > 0
      );

      //Cycle through each Marker with a route
      markersWithRoutes.map(e => {
        //Cycling through Safe and Risky of the Marker
        ["safe", "risky"].map(safeThenRisky => {
          let log = e.gh[safeThenRisky].paths[0].details.distance;
          let classes = e.gh[safeThenRisky].paths[0].details.road_class;

          sum = 0;
          ["primary", "secondary", "tertiary", "residential", "cycleway"].map(
            roadtype => {
              sum = 0;
              let subclass = classes.filter(f => f[2] == roadtype); //returns something like [0,4, residential] [16,20,residential] [25,26,residential]

              subclass.map(g => {
                let individualLog = log.filter(
                  f => f[0] >= g[0] && f[1] <= g[1]
                );
                individualLog.map(e => (sum = sum + e[2]));
                // this.stats[safeThenRisky][roadtype] =
                //   this.stats[safeThenRisky][roadtype] + sum;
              });
              // console.log(`for ${roadtype} sum is ${sum}`);
              this.stats[safeThenRisky][roadtype] =
                this.stats[safeThenRisky][roadtype] + sum;
              sum = 0;
            }
          );

          //Other category of road
          sum = 0;
          let subclass = classes.filter(
            f =>
              f[2] != "primary" &&
              f[2] != "secondary" &&
              f[2] != "tertiary" &&
              f[2] != "residential" &&
              f[2] != "cycleway"
          );

          subclass.map(g => {
            let individualLog = log.filter(f => f[0] >= g[0] && f[1] <= g[1]);
            individualLog.map(e => (sum = sum + e[2]));
            // console.log(`for other sum is ${sum}`);
            // this.stats[safeThenRisky]["other"] =
            //   this.stats[safeThenRisky]["other"] + sum;
          });
          this.stats[safeThenRisky]["other"] =
            this.stats[safeThenRisky]["other"] + sum;
          sum = 0;
        });
      });
    },
    updateChart() {
      var dataset =
        this.uiRouteType == "Safe" ? this.safeRouteV2 : this.riskyRouteV2;

      var width = 125;
      var height = 100;
      var margin = 2;
      var radius = Math.min(width, height) / 2 - margin;

      // eslint-disable-next-line no-unused-vars
      var color = d3.scaleOrdinal([
        "#a05121", //"#8b2222", //"#242424", //Primary
        "#a05121", //"#8b2222", //"#393939", //Secondary
        "#d7c24d", //"#555555", //Tertiary
        "#5a7ebc", //Residential
        "#5e8b79", //"#d7c24d", //Cycleway
        "#8d8d8d" //Other
      ]);

      // eslint-disable-next-line no-unused-vars
      var colorV2 = d3.scaleOrdinal([
        "#a05121", //"#8b2222", //"#242424", //Primary
        "#5a7ebc", //Residential
        "#5e8b79", //"#d7c24d", //Cycleway
        "#8d8d8d" //Other
      ]);

      var svg = d3
        .select(".pieChart")
        .select("svg")
        .select("g");

      var arc = d3
        .arc()
        .innerRadius(25)
        .outerRadius(radius);

      var pie = d3
        .pie()
        .value(d => d[Object.keys(d)]) // Or more verbose... .value(function(d) { return d[Object.keys(d)]; })
        .sort(null);
      // .startAngle(Math.PI / 2)
      // .endAngle(2*Math.PI + Math.PI / 2);

      function arcTween(a) {
        const i = d3.interpolate(this._current, a);
        this._current = i(1);
        return t => arc(i(t));
      }

      // var path =
      svg
        .selectAll("path")
        .data(pie(dataset))
        .join("path") //Or more verbose (old method)... .enter().append("path")
        .attr("fill", (d, i) => colorV2(i))
        .attr("stroke", "white")
        .attr("stroke-width", 1)
        .transition()
        .duration(1500)
        .attrTween("d", arcTween); // .attr("d", arc)

      var emptyArray = dataset.filter(d => d[Object.keys(d)]);
      if (emptyArray == 0) {
        d3.select(".pieChart")
          .select("svg")
          .select("g")
          .selectAll("path")
          .transition()
          .delay(1500)
          .attr("stroke", "none");
      }

      let total =
        this.uiRouteType == "Safe" ? this.safeTotalV2 : this.riskyTotalV2;

      svg
        .selectAll("text")
        .data(pie(dataset))
        .join("text")
        .attr("transform", function(d) {
          return "translate(" + arc.centroid(d) + ")";
        })
        .text(d => {
          // console.log("d", d)

          // if (d.value / total > 0.6) {
          //   return "mainly " + Object.keys(d.data);
          // }

          // if (d.value / total > 0.15) {
          //   return Math.round(d.value * 10) / 10 + "mi";
          // }

          if (d.value / total > 0.15) {
            return Math.round(d.value/total*100) + "%";
          }

        })
        .style("font-size", 20)
        .attr("font-weight", "bold")
        .style("fill", "white")
        .style("font-family", "sans-serif")
        .attr("y", ".2em")
        .attr("text-anchor", "middle");
    },
    randomizeData() {
      this.fakedata.primary = this.getRandomInt(20);
      this.fakedata.secondary = this.getRandomInt(20);
      this.fakedata.tertiary = this.getRandomInt(20);
      this.fakedata.residential = this.getRandomInt(20);
      this.fakedata.cycleway = this.getRandomInt(20);
      this.fakedata.other = this.getRandomInt(10);
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    createVueD3Chart() {
      var width = 125;
      var height = 100;

      let test = d3
        .select(".pieChart")
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", "0 0 125 100")

        .append("g")
        .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

      var colorV2 = d3.scaleOrdinal([
        "#a05121", //"#8b2222", //"#242424", //Primary
        "#5a7ebc", //Residential
        "#5e8b79", //"#d7c24d", //Cycleway
        "#8d8d8d" //Other
      ]);

      const zero = [
        { highstress: 0 },
        { residential: 0 },
        { cycleway: 0 },
        { other: 1 }
      ];

      var margin = 5;
      var radius = Math.min(width, height) / 2 - margin;

      var arc = d3
        .arc()
        .innerRadius(25)
        .outerRadius(radius);

      var pie = d3
        .pie()
        .value(d => d[Object.keys(d)]) // Or more verbose... .value(function(d) { return d[Object.keys(d)]; })
        .sort(null);

      function arcTween(a) {
        const i = d3.interpolate(this._current, a);
        this._current = i(1);
        return t => arc(i(t));
      }

      test
        .append("path")
        // .attr("fill", (d, i) => colorV2(i))
        .transition()
        .duration(1500)
        .attrTween("d", arcTween);
      test
        .append("path")
        .attr("fill", (d, i) => colorV2(i))
        .transition()
        .duration(1500)
        .attrTween("d", arcTween);
      test
        .append("path")
        .attr("fill", (d, i) => colorV2(i))
        .transition()
        .duration(1500)
        .attrTween("d", arcTween);
      test
        .append("path")
        .attr("fill", (d, i) => colorV2(i))
        .transition()
        .duration(1500)
        .attrTween("d", arcTween);
      test
        .selectAll("path")
        .data(pie(zero))
        .join("path") //Or more verbose (old method)... .enter().append("path")
        .attr("fill", (d, i) => colorV2(i))
        .attr("stroke", "white")
        .attr("stroke-width", 1)
        .transition()
        .duration(1500)
        .attrTween("d", arcTween);
    }
  }
};
</script>

<style lang="scss" scoped>
.pieChart {
  position: absolute;
  width: 12vh;
  height: 10vh;
  bottom: 0.5vh;
  left: 5px;
  z-index: 2;
  background-color: #363636;
  // border: solid 1px red;
}

.legend {
  position: absolute;
  width: auto;
  // height: 8vh;
  bottom: 1vh;
  left: calc(40px + 8vh + 10px);
  z-index: 1;
  background-color: #363636;
  // border: solid 1px grey;
  font-size: 11px;
  line-height: 12px;
  font-weight: 900;
  // -webkit-text-stroke-width: .1px;
  // -webkit-text-stroke-color: white;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  align-items: center;
  text-align: start;
}
</style>
